module.exports = __webpack_public_path__ + "img/17.1f40b573.png";